import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { BalanceBadge } from './Fitcoin';
import TappableCard from './TappableCard';
import HamburgerMenuIcon from '../../images/header/HamburgerMenu.svg';
import downIcon from '../../images/common/arrow-down.svg';

import NavigationMenu from './NavigationMenu';

const HeaderContainer = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 15px 34px;
  border-bottom: 1px solid #f0f3f6;
`;

const HeaderLogo = styled.img`
  height: 1.875rem;
`;

const UntappableCard = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-basis: auto;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
`;

const HomeHeader = ({
  balance,
  history,
  showFitCoins,
  sponsorLogo,
  ShowSwitchBenefit,
  enableEntitySwitch,
  dispatch,
}) => {
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);
  const hideModal = () => {
    setShowNavigationMenu(false);
  };

  const config = useSelector((state) => state.app.config);
  return (
    <HeaderContainer>
      {config?.enableEntitySwitch ? (
        <TappableCard
          onTap={() =>
            dispatch({
              type: 'SET_SHOW_SWITCH_BENEFIT_MODAL',
              payload: true,
            })
          }
        >
          <div className="flex gap-4 justify-center items-center border border-primary-shades1 px-2 py-1 rounded-xl">
            <HeaderLogo src={sponsorLogo} alt="Visit Logo" />
            <img src={downIcon} alt="Pcik policy" />
          </div>
        </TappableCard>
      ) : (
        <UntappableCard>
          <div className="flex gap-4 justify-center items-center  px-2 py-1 rounded-xl">
            <HeaderLogo src={sponsorLogo} alt="Visit Logo" />
          </div>
        </UntappableCard>
      )}

      {showFitCoins ? (
        <TappableCard
          onTap={() => history.push('/home/rewards')}
          radius={'38px'}
          border={'1px solid #f0f3f6'}
        >
          <BalanceBadge balance={balance} />
        </TappableCard>
      ) : (
        <div></div>
      )}
      {showNavigationMenu && (
        <NavigationMenu
          hideModal={hideModal}
          showNavigationMenu={showNavigationMenu}
          history={history}
        />
      )}
    </HeaderContainer>
  );
};

HomeHeader.propTypes = {
  balance: PropTypes.string.isRequired,
  showFitCoins: PropTypes.bool.isRequired,
};

export default HomeHeader;
